"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = function () {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }
  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
};
module.exports = exports["default"];